import React, { useContext, useState } from 'react'
import { Box, TextField, Typography } from '@mui/material'
import { QRCodeSVG } from 'qrcode.react'
import SettingsContext from '../../Context/SettingsContext'

const DEFAULT_URL = 'https://develop.evsafe.io/scan?serialNumber={ChargePointId}'

const QRCodeSettings = () => {
  const { settingsState } = useContext(SettingsContext)
  const chargePointId = settingsState.mainSettings.chargePointId || ''

  const defaultResolved = DEFAULT_URL.replace('{ChargePointId}', chargePointId)
  const [url, setUrl] = useState(defaultResolved)

  const resolvedUrl = url

  return (
    <Box>
      <Typography variant='body2' color='text.secondary' sx={{ mb: 2 }}>
        Generate a QR code for scanning.
      </Typography>
      <TextField
        fullWidth
        label='URL'
        size='small'
        variant='outlined'
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        placeholder='https://develop.evsafe.io/scan?serialNumber=YourChargePointId'
        sx={{ mb: 3 }}
      />
      {chargePointId && (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
          <QRCodeSVG value={resolvedUrl} size={200} />
          <Typography variant='caption' color='text.secondary' sx={{ wordBreak: 'break-all', textAlign: 'center', maxWidth: 300 }}>
            {resolvedUrl}
          </Typography>
        </Box>
      )}
      {!chargePointId && (
        <Typography variant='body2' color='error'>
          Please set a Charge Point ID in Main settings first.
        </Typography>
      )}
    </Box>
  )
}

export default QRCodeSettings
